module.exports = __webpack_public_path__ + "3879f18c06b2bf31ae761773b6de5144.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-40.png
// module id = 125
// module chunks = 0